var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"overlay",class:{ show: _vm.isOpen },on:{"click":function($event){_vm.isOpen = !_vm.isOpen}}})])}
var staticRenderFns = []

export { render, staticRenderFns }